(function () {
  'use strict'

  /**
     * @ngdoc service
     * @name ThismomentConfig
     * @module thismoment.config.core
     *
     * @description
     * Sets up a service to pass config values between different modules
     */

  var MODULE_NAME = 'thismoment.config.core'

  require('angular')
    .module(MODULE_NAME, [
    ])
    .provider('ThismomentConfig', tmConfigProvider)

  function tmConfigProvider () {
    var ThismomentConfig = {
      setupConfig: setupConfig
    }

    return {
      setupConfig: setupConfig,
      $get: function () { return ThismomentConfig }
    }

    function setupConfig (properties, methods) {
      var service = {
        get: get,
        set: set,
        properties: angular.isObject(properties) ? properties : {}
      }

      if (angular.isObject(methods)) {
        angular.merge(service, methods)
      }

      return service

      function set (key, value) {
        // pass an object to set() to add multiple properties at once.
        if (angular.isObject(key)) {
          angular.merge(service.properties, key)
          return service.properties
        } else {
          service.properties[key] = value
          return service.properties[key]
        }
      }

      function get (key) {
        return service.properties[key]
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/config/config.js